var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.074 26.676H2.926c-1.432 0-2.593-1.19-2.593-2.657V5.416c0-1.468 1.161-2.658 2.593-2.658h2.592V.102h2.593v2.657h7.778V.102h2.592v2.657h2.593c1.432 0 2.593 1.19 2.593 2.658v18.602c0 1.467-1.161 2.657-2.593 2.657ZM2.926 10.73v13.287h18.148V10.731H2.926Zm0-5.314v2.657h18.148V5.417H2.926ZM18.48 21.36H15.89v-2.657h2.592v2.657Zm-5.185 0h-2.592v-2.657h2.592v2.657Zm-5.185 0H5.518v-2.657h2.593v2.657Zm10.37-5.315H15.89V13.39h2.592v2.657Zm-5.185 0h-2.592V13.39h2.592v2.657Zm-5.185 0H5.518V13.39h2.593v2.657Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.fc12b87bdce7b3e80af68a0ab8df3bcb.svg";
export { ForwardRef as ReactComponent };